import { render, staticRenderFns } from "./certificationActivitiesList.vue?vue&type=template&id=f65a5968"
import script from "./certificationActivitiesList.vue?vue&type=script&lang=js"
export * from "./certificationActivitiesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports